import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconWarningSg = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={15}
    fill="none"
    viewBox="0 0 18 15"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-warning-sg_svg__a)"
      d="M16.813 13.031c.5.875-.125 1.969-1.157 1.969H2.312a1.316 1.316 0 0 1-1.156-1.969L7.844 1.656c.5-.875 1.781-.875 2.312 0l6.656 11.375ZM8.25 5.25v4c0 .438.375.75.75.75a.74.74 0 0 0 .75-.75v-4A.76.76 0 0 0 9 4.5a.74.74 0 0 0-.75.75ZM9 13a.974.974 0 0 0 .969-.969.974.974 0 0 0-.969-.969.98.98 0 0 0-1 .97A.98.98 0 0 0 9 13Z"
    />
    <defs>
      <linearGradient
        id="icon-warning-sg_svg__a"
        x1={17}
        x2={1}
        y1={0}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconWarningSg;
